import React, { useContext } from 'react'
import './topNav.scss'
import { Link, useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa6";
import { FaCircleUser } from "react-icons/fa6";
import { AuthContext } from '../../context/AuthContext';

const TopNav = () => {
  const { teacher } = useContext(AuthContext);




  return (
    <div className="topNav_wrp bk_anim">
      <div className="topNav_in">
        <div className="tp_l">
          <h5>
            Hi Admin <em>Welcome back!</em>{" "}
          </h5>
        </div>
        <div className="tp_r">
          <span>
            <FaCircleUser color="#a0a0a0ff" size={35} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default TopNav
